const TwoColumns = ({ props }) => {
    return (
      <div className="two-columns">
        <div className="left-col">
          <h3>{props.moreInfo.left.title}</h3>
          <p
            dangerouslySetInnerHTML={{ __html: props.moreInfo.left.content }}
          ></p>
          <img
            src={`${process.env.PUBLIC_URL}${process.env.NODE_ENV === `production` ? `/build` : ``}/images/${props.moreInfo.left.image}`}
            alt=""
          />
        </div>
        <div className="right-col">
          <h3>{props.moreInfo.right.title}</h3>
          <p
            dangerouslySetInnerHTML={{ __html: props.moreInfo.right.content }}
          ></p>
          <img
            src={`${process.env.PUBLIC_URL}${process.env.NODE_ENV === `production` ? `/build` : ``}/images/${props.moreInfo.right.image}`}
            alt=""
          />
        </div>
      </div>
    );
}

export default TwoColumns;